import { Spin } from "antd";

import './loader.scss'

const SpinLoader = () => (
    <Spin size="large" />
)

export default SpinLoader